import axios from "axios";

// Create an Axios instance
const axiosInstance = axios.create({
  baseURL: "https://myservice.am/api/v1",
  headers: {
    "Content-Type": "application/json",
  },
});

export default axiosInstance;
